import {
  Col,
  Form,
  Image,
  Input,
  Modal,
  Radio,
  Row,
  Select,
  Checkbox,
  Button,
  Space,
  InputNumber,
} from "antd";
import React, { useEffect, useState } from "react";
import { DeleteOutlined, MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import { useAppContext } from "../../context/AppContext";
import { attributeOption } from "../../constants/var";
import apiPath from "../../constants/apiPath";

const AddForm = ({ api, show, hide, data, refresh, paramsIds, categories }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [category, setCategory] = useState(categories);

  useEffect(() => {
    if (!data) return;
    console.log(data);
    form.setFieldsValue({
      ...data,
      category_id: data?.category_id?._id ? data?.category_id?._id : null,
    });
  }, [data]);

  const onCreate = (values) => {
     const {options} = values
   
    let uniqueOptions = [...new Set(options)]
    if (options?.length !== uniqueOptions?.length) {
       return ShowToast("Please Select Unique Attribute Values!", Severty.ERROR);
    }
    const payload = {
      options : options,
      ...values,
   };
    setLoading(true);
    request({
      url: `${data ? api.addEdit + "/" + data._id : api.addEdit}`,
      method: data ? "PUT" : "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error?.response?.data?.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <Modal
      open={show}
      maskClosable={false}
      width={750}
      okText={data ? `Update` : `Add`}
      cancelText={`Cancel`}
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="tab_modal"
    >
      <Form
        id="create"
        form={form}
        onFinish={onCreate}
        layout="vertical"
        initialValues={{
          is_active: true,
          options: [],
        }}
      >
        <h4 className="modal_title_cls">
          {data ? `Edit Attribute` : `Add New Attribute`}
        </h4>
        <Row gutter={[16, 0]}>
          <Col span={24} sm={12}>
            <Form.Item
              label={<> {"Attribute Name"}</>}
              name="name"
              rules={[
                {
                  required: true,
                  message: "Name is required",
                },
                {
                  max: 200,
                  message: "Name should not contain more then 200 characters!",
                },
                {
                  min: 2,
                  message: "Name should contain at least 2 characters!",
                },
              ]}
              normalize={(value) => value.trimStart()}
            >
              <Input autoComplete="off" placeholder={`Enter Attribute Name`} />
            </Form.Item>
          </Col>
          <Col span={24} md={12}>
            <Form.Item
              label={<> {"Category Name"}</>}
              name="category_id"
              rules={[
                {
                  required: true,
                  message: "Please select the category!",
                },
              ]}
            >
              <Select
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                showSearch
                placeholder={"Select Category"}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
              >
                {category.map((item) => (
                  <Select.Option
                    key={item._id}
                    label={item.name}
                    value={item._id}
                  >
                    {item?.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Row gutter={[12, 0]}>
            <Col span={24}  md={24} xl={24}>
              <Form.List name="options" className="mt-2">
                {(fields, { add, remove }, { form }) => (
                  <>
                    <Row gutter={[12, 0]}>
                      {fields.map((field, index) => (
                        <Col span={24} sm={12}>
                          <div key={field.key}>
                            <Space
                              key={field.key}
                              align="baseline"
                              className="gap-cls"
                            >
                              <div
                                className=""
                                style={{ display: "flex", gap: "8px" }}
                              >
                                <Form.Item
                                  className="qty-cls w-100 customRowDesign"
                                  {...field}
                                  name={[field.name]}
                                  label={
                                    "Attribute Values (" + (index + 1) + ")"
                                  }
                                  rules={[
                                    {
                                      required: true,
                                      message:
                                        "Please enter attribute option value",
                                    },
                                  ]}
                                  normalize={(value) => value.trimStart()}
                                >
                                  <Input
                                    autoComplete="off"
                                    placeholder="Enter Attribute Value"
                                  />
                                </Form.Item>

                                {index > 0 ? (
                                  <div
                                    className="minus-wrap"
                                    style={{ marginTop: "11px" }}
                                  >
                                    <MinusCircleOutlined
                                      className="btnminus"
                                      onClick={() => remove(field.name)}
                                    />
                                  </div>
                                ) : null}
                              </div>
                            </Space>
                          </div>
                        </Col>
                      ))}
                      <Col span={24} sm={12}>
                        <Form.Item label="Add Values" className="">
                          <Button
                            className="btnStylse 1addvaluebtn"
                            onClick={() => add()}
                            block
                            icon={<PlusOutlined />}
                          ></Button>
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                )}
              </Form.List>
            </Col>
          </Row>

     
        </Row>
      </Form>
    </Modal>
  );
};

export default AddForm;
